import { ContainerModuleLoader, withDependencies } from '@wix/thunderbolt-ioc'
import { PageResourceFetcherSymbol, PageStyleLoaderSymbol } from './symbols'
import { IPageResourceFetcher } from './IPageResourceFetcher'
import { ClientPageStyleLoader, ILoadPageStyle, ServerPageStyleLoader } from './PageStyleLoader'
import { IPageAssetsLoader, PageAssets, PageAssetsLoaderSymbol } from '@wix/thunderbolt-symbols'
import { PageResourceFetcher } from './PageResourceFetcher'

type PageAssetsLoaderFactory = (
	pageResourceFetcher: IPageResourceFetcher,
	pageStyleLoader: ILoadPageStyle
) => IPageAssetsLoader

const pageAssetsLoaderImplFactory: PageAssetsLoaderFactory = (pageResourceFetcher, pageStyleLoader) => {
	const assetsCache: Record<string, PageAssets> = {}

	const createPageAssets = (pageCompId: string): PageAssets => {
		const addCssPromise = pageStyleLoader.load(pageCompId)
		const pageFeatures = pageResourceFetcher.fetchResource(pageCompId, 'features', 'enable')

		return {
			components: pageFeatures.then(({ structure: { components } }) => components),
			features: pageFeatures.then(({ structure: { features } }) => features),
			siteFeaturesConfigs: pageFeatures.then(({ structure: { siteFeaturesConfigs } }) => siteFeaturesConfigs),
			props: pageFeatures.then(({ props }) => props),
			css: addCssPromise,
		}
	}

	return {
		load: (pageCompId: string) => {
			assetsCache[pageCompId] = assetsCache[pageCompId] || createPageAssets(pageCompId)
			return assetsCache[pageCompId]
		},
	}
}

const PageAssetsLoaderImpl = withDependencies(
	[PageResourceFetcherSymbol, PageStyleLoaderSymbol],
	pageAssetsLoaderImplFactory
)

export const site: ContainerModuleLoader = (bind) => {
	bind<IPageAssetsLoader>(PageAssetsLoaderSymbol).to(PageAssetsLoaderImpl)
	bind<IPageResourceFetcher>(PageResourceFetcherSymbol).to(PageResourceFetcher)
	if (process.env.browser) {
		bind<ILoadPageStyle>(PageStyleLoaderSymbol).to(ClientPageStyleLoader)
	} else {
		bind<ILoadPageStyle>(PageStyleLoaderSymbol).to(ServerPageStyleLoader)
	}
}
